<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-content-li">
        <div class="footer-content-title">关于我们</div>
        <ul class="footer-ul">
          <li class="clearfix">
            <div
              class="footer-libox"
              onclick="location.href='./../../views/gy/guanyuwomen.html'"
            >
              <span>企业简介</span>
            </div>
          </li>
          <li class="clearfix">
            <div
              class="footer-libox"
              onclick="location.href='./../../views/gy/guanyuwomen.html'"
            >
              <span>联系我们</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="footer-content-li1">
        <div class="footer-content-title">联系我们</div>
        <ul class="footer-ul">
          <li class="clearfix">
            <img
              class="contactUs_img"
              style="top: 3px"
              src="./../assets/icon/youjian@2x.png"
              alt=""
            />
            <span>邮箱：yuncaitech@cyc-fund.com</span>
          </li>
          <li class="clearfix">
            <img
              class="contactUs_img"
              src="./../assets/icon/dizhi@2x.png"
              alt=""
            />
            <span>北京市海淀区融汇国际大厦二层</span>
          </li>
          <li class="clearfix">
            <img
              class="contactUs_img"
              src="./../assets/icon/iphone.png"
              alt=""
            />
            <span>电话：13001143842</span>
          </li>
        </ul>
      </div>
      <div class="footer-content-li2">
        <div class="footer-content-title">相关链接</div>
        <ul class="footer-ul">
          <li class="clearfix">
            <div class="footer-libox">
              <span>中华人民共和国中央人民政府</span>
            </div>
          </li>
          <li class="clearfix">
            <div class="footer-libox">
              <span>中华人民共和国国家发展和改革委员会</span>
            </div>
          </li>
          <li class="clearfix">
            <div class="footer-libox">
              <span>中华人民共和国财政部</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="footer-content-li2">
        <div class="footer-content-title">&nbsp;</div>
        <ul class="footer-ul">
          <li class="clearfix">
            <div class="footer-libox">
              <span>国家信息中心</span>
            </div>
          </li>
          <li class="clearfix">
            <div class="footer-libox">
              <span>中宏网|国家经济视窗</span>
            </div>
          </li>
          <li class="clearfix">
            <div class="footer-libox">
              <span>公共资源网</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-bottomtxt">
      Copyright©2017-2024,www.zhonghongwang.com. All rights reserved.
      &nbsp;&nbsp;|&nbsp;&nbsp; ICP证：京ICP备19016327号 &nbsp;&nbsp; |
      <a id="baNum" target="_blank" href="http://beian.miit.gov.cn/"
        >京ICP备19045306号-1</a
      >
      &nbsp;&nbsp; 北京云采科技有限公司提供技术支持
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>
<style lang="less" scoped>
.footer {
  background: #e8eaef;
  // margin-top: 20px;

  &-content {
    padding-top: 46px;
    color: #666;
    width: 1200px;
    margin: 0 auto;

    &-li {
      width: 232px;
      float: left;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }

    &-li1 {
      width: 310px;
      float: left;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }

    &-li2 {
      width: 320px;
      float: left;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }

    &-title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }
  }

  &-ul {
    margin: 0;
    padding: 0;
    padding-top: 10px;

    li {
      list-style: none;
      margin-top: 13px;
      line-height: 1.4;
      font-size: 14px;
    }
  }

  &-libox {
    cursor: pointer;
    position: relative;

    span {
      display: block;
    }

    span:hover {
      color: #b6141a;
    }
  }

  &-bottomtxt {
    width: 1200px;
    margin: 0 auto;
    text-align: right;
    bottom: 0px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    color: #666;
    margin-top: 160px;
    font-size: 14px;
    padding-bottom: 35px;
    text-align: center;
  }

  #baNum {
    color: #666;
    text-decoration: none;
  }

  #baNum:link {
    color: #666;
  }

  #baNum:hover {
    color: #666;
  }

  #baNum:active {
    color: #666;
  }
}
</style>
